import { ArrowDownIcon, ArrowUpIcon, XIcon } from '@phosphor-icons/react';
import { T, Var, useGT, useMessages } from 'gt-react';
import type { As400GridSort } from '@erp/rpc';
import { Button } from '@/components/ui/button';
import { AS400_EXPORT_GROUP_LABELS } from './as400Groups';
import { sortColumnHeader } from './as400GridSort';

/**
 * The review's active column sort, named in the grid toolbar with a way to
 * clear it. It shows on every worksheet: the sort applies to all of them, and
 * on a worksheet without the sorted column this is the only sign rows are
 * sorted at all.
 */
export function As400GridSortChip({
  sort,
  onClear,
}: {
  sort: As400GridSort | null;
  onClear: () => void;
}) {
  const gt = useGT();
  const m = useMessages();
  if (!sort) return null;
  const DirectionIcon = sort.direction === 'asc' ? ArrowUpIcon : ArrowDownIcon;
  return (
    <span className="inline-flex items-center gap-1 rounded-md border bg-muted/50 py-0.5 pl-2 pr-0.5 text-xs text-muted-foreground">
      <DirectionIcon className="h-3 w-3" aria-hidden="true" />
      <T context="review grid toolbar: the column every worksheet is sorted by, then (in parentheses) the worksheet tab that column belongs to, e.g. 'Sorted by CDB (Price tab)'">
        Sorted by <Var>{sortColumnHeader(sort)}</Var> (
        <Var>{m(AS400_EXPORT_GROUP_LABELS[sort.group])}</Var> tab)
      </T>
      <Button
        variant="ghost"
        size="icon"
        className="h-5 w-5"
        onClick={onClear}
        aria-label={gt('Clear sort', {
          context: 'review grid toolbar: remove the column sort',
        })}
      >
        <XIcon className="h-3 w-3" />
      </Button>
    </span>
  );
}
